import React, { useContext } from "react";
import PropTypes from "prop-types";
import UserPrefsContext from "../../../context/UserPrefs/UserPrefsContext";
import { useIntl } from "react-intl";
import ButtonGroup from "../../shared/InputElements/ButtonGroup";

const ChooseLowIncomeProgram = ({
     id = "low-income-program",
     label = "Are you enrolled in a low income program?",
     incentives,
     ...rest
}) => {
     const intl = useIntl();
     const userPrefs = useContext(UserPrefsContext);
     const inLIHEAP = userPrefs.get("enrolledLIHEAP");

     return (
          <ButtonGroup
               id="liheap-indicator-buttons"
               value={inLIHEAP === "tbd" ? null : inLIHEAP.toString()}
               label={
                    intl.formatMessage
                         ? intl.formatMessage({
                                id: "chargingadvisor.catalog.enrolledInLowIncome",
                                defaultMessage: "Enrolled in Low Income Energy Program?",
                           })
                         : "Enrolled in Low Income Energy Program?"
               }
               extraLabelClass="longLabel"
               optionNames={[
                    intl.formatMessage({ id: "yes", defaultMessage: "Yes" }),
                    intl.formatMessage({ id: "no", defaultMessage: "No" }),
               ]}
               optionValues={["true", "false"]}
               tooltip={
                    intl.formatMessage
                         ? intl.formatMessage({
                                id: "home-charger-incentive-catalog.liheap",
                                defaultMessage:
                                     "If you are currently enrolled in your utility’s Low Income Home Energy Assistance Program (LIHEAP) you may be eligible to a savings booster.",
                           })
                         : "If you are currently enrolled in your utility’s Low Income Home Energy Assistance Program (LIHEAP) you may be eligible to get additional incentives."
               }
               handler={(e, selected) => {
                    userPrefs.set({ enrolledLIHEAP: selected === "true" });
               }}
          />
     );
};

export default ChooseLowIncomeProgram;

ChooseLowIncomeProgram.propTypes = {
     id: PropTypes.string,
     label: PropTypes.string,
     incentives: PropTypes.array,
};
